import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const CancellationPolicy = () => {
  return (
    <>
      <Meta 
        title="Cancellation & Refund Policy - VEDA Merchandise"
        description="Read our cancellation and refund policy for VEDA mythological toys, games, and puzzles."
        keywords="cancellation policy, refund policy, VEDA policy, mythological toys policy"
        author="VEDA Merchandise"
        ogTitle="Cancellation & Refund Policy - VEDA Merchandise"
        ogDescription="Read our cancellation and refund policy for VEDA mythological toys, games, and puzzles."
        ogImage="https://vedamerchandise.com/policy-preview.jpg"
        ogUrl="https://vedamerchandise.com/cancellation-refund-policy"
        ogType="article"
        twitterCard="summary_large_image"
        twitterTitle="Cancellation & Refund Policy - VEDA Merchandise"
        twitterDescription="Read our cancellation and refund policy for VEDA mythological toys, games, and puzzles."
        twitterImage="https://vedamerchandise.com/policy-preview.jpg"
        robots="index, follow"
        canonicalUrl="https://vedamerchandise.com/cancellation-refund-policy"
      />
      <Container className="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="policy">
              <p>
                ASTRAPE. AI PRIVATE LIMITED believes in helping its customers as
                far as possible, and has therefore a liberal cancellation policy.
                Under this policy:
              </p>
              <p>
                Cancellations will be considered only if the request is made
                within 7 days of placing the order. However, the cancellation
                request may not be entertained if the orders have been
                communicated to the vendors/merchants and they have initiated the
                process of shipping them.
              </p>
              <p>
                ASTRAPE. AI PRIVATE LIMITED does not accept cancellation requests
                for perishable items like flowers, eatables etc. However,
                refund/replacement can be made if the customer establishes that
                the quality of product delivered is not good.
              </p>
              <p>
                In case of receipt of damaged or defective items please report
                the same to our Customer Service team. The request will, however,
                be entertained once the merchant has checked and determined the
                same at his own end. This should be reported within 7 days of
                receipt of the products.
              </p>
              <p>
                In case you feel that the product received is not as shown on the
                site or as per your expectations, you must bring it to the notice
                of our customer service within 7 days of receiving the product.
                The Customer Service Team after looking into your complaint will
                take an appropriate decision.
              </p>
              <p>
                In case of complaints regarding products that come with a
                warranty from manufacturers, please refer the issue to them.
              </p>
              <p>
                In case of any Refunds approved by the ASTRAPE. AI PRIVATE
                LIMITED, it'll take 9-15 days for the refund to be processed to
                the end customer.
              </p>
              <p>
                <strong>Disclaimer:</strong> The above content is created at
                ASTRAPE. AI PRIVATE LIMITED's sole discretion. Razorpay shall not
                be liable for any content provided here and shall not be
                responsible for any claims and liability that may arise due to
                merchant's non-adherence to it.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default CancellationPolicy;